import styled from 'styled-components'

export const MenuWrap = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 183px;
  background: #FFFFFF;
  border: 1px solid #EDEDEE;
  border-radius: 10px;
  box-shadow:
    0px 4px 6px -2px rgba(16, 24, 40, 0.04),
    0px 14px 16px -2px rgba(16, 24, 40, 0.08);
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 40;

  /* entry animation */
  opacity: 0;
  transform: translateY(6px) scale3d(0.96, 0.96, 0.96);
  animation: menu-in 140ms ease forwards;

  @keyframes menu-in {
    to {
      opacity: 1;
      transform: translateY(0) scale3d(1, 1, 1);
    }
  }
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border-radius: 8px;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: #101018;
  font-size: 14px;
  letter-spacing: -0.0248em;

  transition: background-color .15s ease, color .15s ease;
  &:hover { background: #F9F9FA; }

  svg { color: #6D6D72; }

  &.danger {
    color: #DD524D;
    svg { color: #DD524D; }
  }
`;
